import {observer} from 'mobx-react-lite'
import React, {useLayoutEffect, useRef} from 'react'
import tw from 'tailwind-styled-components'
import {logger} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {useScrollFade} from '@components/main-menu/menu-items/use-scroll-fade'
import {dragPropsFromCtl, useDraggable} from '@containers/hooks-draggable'
import {WithPerfectScrollbar} from '../../common/with-scrollbar/with-scrollbar'
import {useMainMenuStore} from '../main-menu-store'
import {getFlexBasis} from './chats-list'
import {ProjectsItem} from './projects-item'

const TwProjectList = tw(WithPerfectScrollbar)`
  flex
  flex-col

  flex-initial
  cursor-pointer

  -mr-8
  pr-8
  perfect-scrollbar-with-custom-scroll
`

const TwDragBottomTarget = tw.div<{$dragOver: boolean}>`
    h-28
    min-h-28
    max-h-28
    bg-grey
    w-224
    rounded-4

    ${p =>
      p.$dragOver
        ? `
            border-0
            border-solid
            border-t-2
            border-action-default
          `
        : ''}
`

export const ProjectsList = observer(() => {
  const [state, store] = useMainMenuStore()
  const {projects} = state
  const dragCtl = useDraggable<DataObjectId | 'bottom'>({
    onDrop: (id, to) => {
      if (id === 'bottom') {
        logger.log('Not supported project', id)
      } else {
        store.onProjectReorder(id, to)
      }
    }
  })

  const flexBasis = getFlexBasis(projects)
  const cls = projects.length <= 1 ? 'min-h-28' : 'mih-h-56'

  const containerRef = useRef<HTMLElement>()
  const {refreshFade} = useScrollFade(containerRef)
  useLayoutEffect(() => {
    refreshFade()
  }, [projects.length, refreshFade])

  if (!projects.length) {
    return null
  }

  return (
    <TwProjectList
      style={{flexBasis}}
      className={cls}
      containerRef={el => (containerRef.current = el)}
      onScroll={refreshFade}
    >
      {projects.map(p => (
        <ProjectsItem p={p} key={p.projectId} dragCtl={dragCtl} />
      ))}
      {!!dragCtl.draggedId && (
        <TwDragBottomTarget
          $dragOver={dragCtl.dragOverId === 'bottom'}
          {...dragPropsFromCtl('bottom', dragCtl)}
        />
      )}
    </TwProjectList>
  )
})
